import bowser from 'yola-bowser';
import contentEditable from '../../content-editable';
import insertSpaceOnButtonKeyDown from '../utils/helpers/insert-space-on-button-key-down';
import proxyKeydownToParentContext from '../utils/helpers/proxy-keydown-to-parent-context';
import insertSpaceOnElementKeydown from '../utils/helpers/insert-space-on-element-keydown';
import preventNativeContentEditing from '../utils/helpers/prevent-native-content-editing';
import editingSelectedLinkKeydownWorkaround from '../utils/helpers/editing-selected-link-keydown-workaround';
import blurElementOnSaveHotkey from '../utils/helpers/blur-element-on-save-hotkey';
import preventTabHandling from '../utils/helpers/prevent-tab-handling';
import preventRootLevelEditing from '../utils/helpers/firefox-workarounds/prevent-root-level-editing';
import handleEmptyEditableElement from '../utils/helpers/firefox-workarounds/handle-empty-editable-element';

const documentKeydownHandler = (event) => {
  const { srcElement } = event;
  const isContentEditable = srcElement.hasAttribute('contenteditable');

  proxyKeydownToParentContext(event);
  blurElementOnSaveHotkey(event);
  preventTabHandling(event);

  if (isContentEditable) {
    contentEditable.handlers.spaceHandler(event);
    contentEditable.handlers.checkpointDelayHandler(event);
    contentEditable.handlers.returnHandler(event);
    contentEditable.handlers.backspaceHandler(event);
    contentEditable.handlers.deleteHandler(event);
    contentEditable.helpers.triggerInputAfterReturn(event);
    if (bowser.firefox) {
      preventRootLevelEditing(event);
    }
    insertSpaceOnButtonKeyDown(event);
    preventNativeContentEditing(event);
    insertSpaceOnElementKeydown(event);
    editingSelectedLinkKeydownWorkaround(event);
    if (bowser.firefox) {
      handleEmptyEditableElement(event);
    }
  }
};

export default documentKeydownHandler;
